import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';

export const Section = styled.div`
  padding: 20px 14px;
  ${MOBILE_QRY} {
    display: flex;
    padding: 32px 34px;
  }
`;

export const FooterSection = styled.div`
  padding: 8px 16px;
  display: flex;
  bottom: 0;
  z-index: 2;
  position: sticky;
  border-top: 1px solid var(--border1);
  background: var(--content1);

  ${MOBILE_QRY} {
    position: sticky;
    padding: 18px 34px;
  }
`;

export const SectionDesc = styled.div`
  min-width: 292px;
  max-width: 292px;
  padding: 0 0 12px 0;

  ${MOBILE_QRY} {
    padding: 0 40px 0px 0;
  }
`;

export const OptionWrapper = styled.div`
  height: 44px;
  border-radius: 0 4px 4px 0;
  border: 1px solid #ccced0;
  border-left: none;
`;

export const OptionItem = styled.div<{ isActive?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  color: ${props => (props.isActive ? 'var(--prim3)' : 'var(--prim1)')};
  background: ${props => (props.isActive ? 'var(--neut7)' : 'none')};
  height: 100%;
  min-width: 45px;
  &:hover {
    background: var(--hover1);
  }
  &:last-of-type {
    border-radius: 0 4px 4px 0;
  }
`;

export const ColorBox = styled.div`
  width: 200px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--border1);
`;
